module.exports = "/build/web/svg/close.4d34a2d0097502c06633ede2c5150dee.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/close.svg
// module id = 122
// module chunks = 13